import { asGradingId } from "@repo/app-types/entities/teammatePerformanceSummary";
import { useCallback, type FC } from "react";
import { useNavigate, useParams } from "react-router";
import type { BuildCriterionPath } from "../../app/routes/gradingRoutes.js";
import { GradingValidationDialogContainer } from "./gradingValidationDialogContainer.js";

interface TrainingTeammatePageRecordingGradeProps {
  /** Builds this route family's URL for another criterion of the grading. */
  buildCriterionPath: BuildCriterionPath;
}

export const TrainingTeammatePageRecordingGrade: FC<
  TrainingTeammatePageRecordingGradeProps
> = ({ buildCriterionPath }) => {
  const params = useParams();
  const { gradingId: gradingIdParam, criterionId: sectionOrCriteriaId } =
    params;
  if (!gradingIdParam || !sectionOrCriteriaId) {
    throw new Error("Missing params.");
  }

  const gradingId = asGradingId(gradingIdParam);

  const navigate = useNavigate();

  // Navigation callback for criteria selection: same URL, swapped criterion.
  const handleCriteriaSelect = useCallback(
    (newCriterionId: string) => {
      navigate(buildCriterionPath(params, newCriterionId));
    },
    [navigate, buildCriterionPath, params],
  );

  return (
    <GradingValidationDialogContainer
      gradingId={gradingId}
      sectionOrCriteriaId={sectionOrCriteriaId}
      onCriteriaSelect={handleCriteriaSelect}
    />
  );
};
